export default {
  methods: {
    assignThirdPartyTrackerType(trackers = {}) {
      /**
       * Loop over the trackers object to get Arrays of trackers,
       * Then flatten them into one Array
       */
      return Object.keys(trackers).flatMap((key) => {
        // Array of Trackers using key
        const trackerItems = trackers[key];
        // Assign a type property to each tracker and return an array of trackers...
        return trackerItems.map((tracker) => ({ ...tracker, type: key }));
      });
    },
  },
};
